export const ASSET_NOT_FOUND = 'ylandsApiService.assetNotFound';
export const ASSET_BLOCKED = 'ylandsApiService.assetBlocked';
export const PROFILE_NOT_FOUND = 'ylandsApiService.profileNotFound';
export const SESSION_EXPIRED = 'SESSION_EXPIRED';
export const SPACE_EXCEEDED = 'spaceExceeded';
export const STORAGE_SPACE_QUOUTA_EXCEEDED =
    'storageApiService.exceededSpaceQuota';
export const RESOURCE_VERSION_CHANGED =
    'creatorsClubApi.resourceVersionChanged';
export const NO_ACTIVE_SUBSCRIPTION = 'creatorsClubApi.noActiveSubscription';
export const CREATION_SCREENSHOT_LIMIT_REACHED =
    'creatorsClubApi.screenshotLimitReached';
export const NOT_ENOUGH_CURRENCY = 'creatorsClubApi.notEnoughCurrency';
export const CASHBACK_INVALID_AMOUNT = 'creatorsClubApi.cashbackInvalidAmount';
export const CASHBACK_AMOUNT_TOO_LOW = 'creatorsClubApi.cashbackAmountTooLow';
export const CASHBACK_DIFFERENT_MONEY_AMOUNT_CALCULATED =
    'creatorsClubApi.cashbackDifferentMoneyAmountCalculated';
export const CASHBACK_UNSUPPORTED_STATE_TRANSITION =
    'creatorsClubApi.unsupportedStateTransition';
export const NOT_FOUND = 'storageApiService.fileNotFound';
export const SPACE_QUOTA = 'storageApiService.exceededSpaceQuota';
export const CONTENT_TYPE = 'storageApiService.invalidContentType';
export const METADATA = 'storageApiService.invalidMetadata';
export const FILE_SIZE = 'storageApiService.exceededFileSize';
export const PARTS_NUMBER = 'storageApiService.exceededPartsAmount';
export const FILES_NUMBER = 'storageApiService.exceededFilesNumber';
export const FIELDS_NUMBER = 'storageApiService.exceededFieldsNumber';
export const UPLOAD = 'storageApiService.uploadError';
export const STORAGE = 'storageApiService.storageError';
export const DATABASE = 'storageApiService.databaseError';
export const ACCESS_DENIED = 'storageApiService.accessDenied';
export const NO_FILE = 'storageApiService.noFile';
export const UNSUPPORTED_FILE_TYPE = 'storageApiService.unsupportedFileType';
export const NOT_DELETED = 'storageApiService.fileNotDeleted';
export const NOT_FOUND_IN_STORAGE = 'storageApiService.fileNotFoundInStorage';
export const REMOVED_FROM_STORAGE = 'storageApiService.fileRemovedFromStorage';
export const PROFILE_EXISTS = 'storageApiService.profileExists';
export const SPACE_EXISTS = 'storageApiService.spaceExists';
export const SPACE_NOT_FOUND = 'storageApiService.spaceNotFound';
export const USER_NOT_FOUND = 'storageApiService.userNotFound';
export const USER_SPACE_NOT_FOUND = 'storageApiService.userSpaceNotFound';
export const SCOPE_OUT_OF_RANGE = 'storageApiService.scopeOutOfRange';
export const FILE_TYPE_NOT_ALLOWED = 'storageApiService.fileTypeNotAllowed';
export const USER_EXCEEDED_SPACE_QUOTA_LIMIT =
    'storageApiService.userExceededSpaceQuotaLimit';
export const USER_EXCEEDED_FILE_NUMBER_LIMIT =
    'storageApiService.userExceededFileNumberLimit';
export const INVALID_MANIFEST = 'storageApiService.invalidManifest';
export const UNSUPPORTED_ZIP_VERSION =
    'storageApiService.unsupportedZipVersion';
